import React from "react";
import { useMediaQuery } from "react-responsive";

export const WindowContext = React.createContext<{
  device?: "phone" | "tablet" | "desktop";
}>({});

const WindowProvider: React.FC<React.PropsWithChildren<unknown>> = (props) => {
  const isPhone = useMediaQuery({ maxWidth: 768 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  return (
    <WindowContext.Provider
      value={{
        device: isPhone ? "phone" : isTablet ? "tablet" : "desktop",
      }}
    >
      {props.children}
    </WindowContext.Provider>
  );
};

export default WindowProvider;
